import React from "react";
/* eslint-disable */
import {
    Box,
    TableBody, TableCell, TableContainer, TableHead, TableRow, Table,
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

    render() {
        const grnData = this.props.grnList;
        const totalValues = this.props.totalValues;
        return (
            <div>
                <br />
                <br />
                <h3><center><u>Reject GRN Detail Report</u></center></h3>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <Box minWidth={1050}>
                    <TableContainer style={{ marginLeft: '5px' }}>
                        <Table aria-label="caption table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align={'left'}>GRN Date </TableCell>
                                    <TableCell align={'left'}>GRN Number </TableCell>
                                    <TableCell align={'left'}>Supplier Code </TableCell>
                                    <TableCell align={'left'}>Full name </TableCell>
                                    <TableCell align={'right'}>Total value </TableCell>
                                    <TableCell align={'left'}>Remark </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {grnData.map((data, index) => (
                                    <TableRow key={index}>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {new Date(data.grnDate).toLocaleDateString()}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.invoiceNumber == null ? '-' : data.invoiceNumber}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.farmerCode == null ? '-' : data.farmerCode}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.middleName == null ? '-' : data.middleName}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.totalAmount == null ? '-' : parseFloat(data.totalAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.remark == null ? '-' : data.remark}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableRow>
                                <TableCell align="left" colSpan={4} style={{ fontWeight: "bold" }}>Total</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalAmount == null ? '-' : parseFloat(totalValues.totalAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                <TableCell ></TableCell>
                            </TableRow>
                        </Table>
                    </TableContainer>
                </Box>
            </div>

        );
    }
}
